import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { userShape } from './ThreadItem';

const LeaderboardItem = ({ user, score }) => {
  const { authUser = null } = useSelector((states) => states);
  return (
    <li className="flex items-center gap-4 justify-between">
      <div className="flex gap-3 items-center min-h-[40px]">
        <img src={user.avatar} alt="user's avatar" className="w-[40px] rounded-full" />
        <h3 className="text-lg font-normal tracking-wider text-black w-40 sm:w-full text-ellipsis overflow-y-clip" title={user.name}>
          {user.name}
          {' '}
          {authUser?.id === user.id ? (<em>(You)</em>) : ''}
        </h3>
      </div>
      <p className="text-2xl text-black tracking-wider font-medium">{score}</p>
    </li>
  );
};

const leaderboardItemShape = {
  user: PropTypes.shape(userShape).isRequired,
  score: PropTypes.number.isRequired,
};
LeaderboardItem.propTypes = {
  ...leaderboardItemShape,
};

export { leaderboardItemShape };

export default LeaderboardItem;
